export function officeExclusiveAddendumCP826() {
return [   // Release 2026-09-08 18:15:04
 
{
   page: 0,
   name: "Agent Brokerage Firm Name 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 228.84,
   width: 329.04,
   height: 12.00
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 145.32,
   left: 216.12,
   width: 322.92,
   height: 12.00
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 168.12,
   left: 216.12,
   width: 322.92,
   height: 12.00
}
,
{
   page: 0,
   name: "Date Listing Contract Date", 
   fontSize: 9,
   type: "date",
   top: 191.16,
   left: 216.12,
   width: 322.92,
   height: 12.00
}
,
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 213.96,
   left: 216.12,
   width: 322.92,
   height: 12.00
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 236.64,
   left: 216.12,
   width: 322.92,
   height: 12.00
}
,
{
   page: 0,
   name: "Date Office Exclusive Addendum", 
   fontSize: 9,
   type: "date",
   top: 259.68,
   left: 216.12,
   width: 322.92,
   height: 12.00
}
,
{
   page: 0,
   name: "numberDays", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 399.48,
   left: 392.64,
   width: 48.00,
   height: 12.00
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 228.84,
   width: 329.04,
   height: 12.00
}
,
{
   page: 1,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.502,
   left: 72.0,
   width: 378.24,
   height: 14.018
}
,
{
   page: 1,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 324.502,
   left: 455.4,
   width: 76.8,
   height: 14.018
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
] }
